import { BaseBadge } from './BaseBadge';
import { BaseToolBadgeProps } from './types';

export const VerifyCaseContextBadge = ({
  isDone,
  ...props
}: BaseToolBadgeProps) => {
  const allProps = { ...props, isDone };

  return (
    <BaseBadge
      {...allProps}
      showArgs={false}
      resultTexts={{
        loading: 'Verifying case context…',
        done: 'Case context verified',
        error: 'Case context issues',
      }}
    />
  );
};
